<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-icon class="mr-1" color="green">mdi-office-building</v-icon>
            Organization
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="addNewItem">
                + ADD
            </v-btn>
        </v-card-title>

        <!-- Dialog for confirm delete user -->
        <v-dialog v-model="dialogItem.deleteConfirmation" max-width="400px">
            <v-card>
                <v-card-title class="text">{{ dialogItem.confirmText }}</v-card-title>
                <v-card-actions v-if="dialogItem.confirmAction">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                <v-card-actions v-else>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="actionDeleteItem">Yes</v-btn>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">No</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- table list -->
        <v-data-table :headers="headers" :items="itemList" :search="search" sort-by="name" :sort-desc="false" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="loading">
            <template v-slot:[`item.coachNumber`]="{ item }">
                <v-icon class="mr-2" title="Coach" v-if="isSuperAdmin || isAccessOrgAdmin" @click="goToCoachList(item)">
                    mdi-calendar-account
                </v-icon> {{ item.coachNumber }}
            </template>
            
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon class="mr-2" @click="editItemAction(item)" title="Edit">
                    mdi-pencil
                </v-icon>

                <v-icon class="mr-2" @click="dialogDeleteItem(item)" title="Delete">
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </v-card>
</v-container>
</template>

    
    
<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import getOrgList from "../data/getOrgList";
import removeOrg from "../data/removeOrg";
import getUserCoachList from "../data/getUserCoachList";
export default {
    name: 'OrganizationList',
    metaInfo: {
        title: 'Organization List'
    },
    data() {
        return {
            loading: false,
            search: "",
            options: {
                itemsPerPage: 20,
            },
            headers: [{
                    text: "Name",
                    value: "name"
                },
                {
                    text: "Coach",
                    value: "coachNumber"
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                },
            ],
            itemList: [],

            dialogItem: {
                confirmAction: false,
                confirmText: "Do you want to delete this org?",
                deleteConfirmation: false,
                deletedItemId: null,
            },
            dialogItemDefault: {
                confirmAction: false,
                confirmText: "Do you want to delete this org?",
                deleteConfirmation: false,
                deletedItemId: null,
            }
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Organization";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessOrgAdmin"
        ]),
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isAccessOrgAdmin) {
                (async () => {
                    this.loading = true;
                    this.itemList = await getOrgList();

                    if (this.itemList.length) {
                        await Promise.all(
                            this.itemList.map(async (item) => {
                                const coachInfo = await getUserCoachList(item.id);
                                item.coachNumber = coachInfo.length;
                                item.allowToManage = false;
                            })
                        );
                    }
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        // //dialog
        addNewItem() {
            this.$router.push(`/org-add`);
        },
        editItemAction(item) {
            this.$router.push(`/org-edit/${item.id}`);
        },
        goToCoachList(item) {
            this.$router.push(`/org-coach/${item.id}`);
        },

        // //delete
        dialogDeleteItem(item) {
            this.dialogItem.deleteConfirmation = true; //show popup
            this.dialogItem.deletedItemId = item.id; //assign delete item id

            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },
        actionDeleteItem() {
            (async () => {
                await removeOrg(this.dialogItem.deletedItemId);
                this.dialogItem.confirmAction = true;
                this.dialogItem.confirmText = "Done!";

                this.dialogItem.deleteConfirmation = false;
                this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
                await this.initialize();
            })();
        },
        closeConfirmationDialog() {
            //To result default value
            this.dialogItem.deleteConfirmation = false;
            this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        }
    },
};
</script>
